var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondMemoriesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "secondmemories-pin",
    x1: 138,
    y1: 72,
    x2: 376,
    y2: 448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0E63D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0047B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00338F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "secondmemories-dot",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257 211) rotate(90) scale(47)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFAB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A14"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#secondmemories-pin)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256 469C248.4 469 241.3 465.2 237.1 458.9L128.2 293.1C105 258.7 94 230 94 193C94 103.5 166.5 31 256 31C345.5 31 418 103.5 418 193C418 230 407 258.7 383.8 293.1L274.9 458.9C270.7 465.2 263.6 469 256 469ZM178 194C178 150.9 212.9 116 256 116C299.1 116 334 150.9 334 194C334 227.4 313 255.9 283.5 267.1V369.9C283.5 381.7 269.8 388.2 260.7 380.6L256 376.6L251.3 380.6C242.2 388.2 228.5 381.7 228.5 369.9V267.1C199 255.9 178 227.4 178 194Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 194,
    r: 43,
    fill: "url(#secondmemories-dot)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondMemoriesIcon);
export default __webpack_public_path__ + "static/media/SecondMemoriesIcon.20965cc77a99b34449437b7e929ca2da.svg";
export { ForwardRef as ReactComponent };